// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'

const lw = {
  minWidth: '150px',
}

const TimeStamp = ({ dateLabel, idRoot, info: { timestamp, user }, userLabel }) => (
  <small className={'display-block'}>
    <span
      className={'padding-right-1 display-inline-block'}
      style={lw}>
      <span id={`${idRoot}-date-label`}>
        {`${dateLabel}: `}
      </span>
      <span id={`${idRoot}-date-value`}>
        {timestamp || ''}
      </span>
    </span>
    <span
      className={'padding-left-1 display-inline-block'}
      id={`${idRoot}-value`}>
      <span id={`${idRoot}-user-label`}>
        {`${userLabel}: `}
      </span>
      <span id={`${idRoot}-user-value`}>
        {user || ''}
      </span>
    </span>
  </small>
)

TimeStamp.propTypes = {
  dateLabel: string.isRequired,
  idRoot: string.isRequired,
  info: object,
  userLabel: string.isRequired,
}

export default TimeStamp
